import React from 'react';

import { Box, BoxProps } from '@tanium/react-box';
import { useUsingMouse } from '@tanium/react-mouse-interaction-context';

import { ClickableLegendItem } from './ClickableLegendItem';

type BaseLegendItemProps = Omit<BoxProps<'button'>, 'css'>;

export const BaseLegendItem = ({ children, ...boxProps }: BaseLegendItemProps): JSX.Element => {
  const usingMouse = useUsingMouse();
  const isButton = !!boxProps.onClick;

  return (
    <Box<'button' | 'div'>
      as={isButton ? ClickableLegendItem : undefined}
      display="flex"
      px="2px"
      py={0}
      mt="-2px"
      border={1}
      borderColor="transparent"
      maxWidth="100%"
      {...boxProps}
      {...(isButton && { usingMouse })}
    >
      {children}
    </Box>
  );
};
